<template>
  <div class="history-modal-card modal-card" style="width: auto">
    <section class="modal-card-body">
      <b-table :data="historyData" :columns="columns" focusable> </b-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "SubmissionHistory",
  props: ["historyData"],
  data() {
    return {
      columns: [
        { field: "status", label: "Action" },
        { field: "createdBy", label: "User Name" },
        { field: "nameRole", label: "User Role" },
        { field: "dateCreated", label: "Date" }
      ]
    };
  }
};
</script>
